<template>
  <main-layout>
    <div class="text-left">
      <h1 class="title content-header">Cache PDFs CR</h1>
      <p>Les 50 derniers comptes-rendus mis en cache, du plus récent au plus ancien.</p>
      <v-btn outlined class="mb-4" :loading="loading" :disabled="loading" @click="load">Actualiser</v-btn>
      <v-alert v-if="error" type="error">{{ error }}</v-alert>
      <v-data-table :headers="headers" :items="items" item-key="Report_id" :loading="loading" :items-per-page="50"
        hide-default-footer disable-pagination disable-sort no-data-text="Aucun compte-rendu en cache">
        <template v-slot:item.Report_id="{ item }">CR{{ item.Report_id }}</template>
        <template v-slot:item.ticketNumber="{ item }">{{ item.ticketNumber || item.Ticket_id || '—' }}</template>
        <template v-slot:item.generatedAt="{ item }">{{ date(item.generatedAt) }}</template>
        <template v-slot:item.fileSize="{ item }">{{ size(item.fileSize) }}</template>
        <template v-slot:item.url="{ item }">
          <a :href="item.url" target="_blank" rel="noopener noreferrer">Voir le PDF</a>
        </template>
      </v-data-table>
      <p class="text-caption mt-3">Les liens sont valables une heure. Actualisez la liste pour les renouveler.</p>
    </div>
  </main-layout>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import api from '@/api';
import MainLayout from './MainLayout.vue';

export default {
  components: { MainLayout },
  data: () => ({
    items: [],
    loading: false,
    error: ``,
    headers: [
      { text: `Compte-rendu`, value: `Report_id` },
      { text: `Intervention`, value: `ticketNumber` },
      { text: `Mis en cache le`, value: `generatedAt` },
      { text: `Taille`, value: `fileSize` },
      { text: `PDF`, value: `url` },
    ],
  }),
  mounted() { this.load(); },
  methods: {
    async load() {
      if (this.loading) return;
      this.loading = true; this.error = ``;
      try { const { data } = await api.get(`/report-pdf-cache`); this.items = data.items; } catch (error) {
        this.error = `Impossible de charger le cache des comptes-rendus.`;
      } finally { this.loading = false; }
    },
    date(value) { return value ? new Date(value).toLocaleString(`fr-FR`, { timeZone: `Europe/Paris` }) : `—`; },
    size(value) {
      const bytes = Number(value);
      return bytes >= 1048576 ? `${(bytes / 1048576).toFixed(1)} Mo` : `${Math.ceil(bytes / 1024)} Ko`;
    },
  },
};
</script>
